import React, {ReactNode, ElementType} from 'react';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  routed?: boolean;
  padding?: boolean;
  title?: ReactNode;
  to?: string;
  newTab?: boolean;
  className?: string;
}

const NavbarLink = ({
  routed = true,
  padding = false,
  title,
  to,
  newTab = false,
  className,
}: Props) => {
  const LinkElement: ElementType = routed ? Link : 'a';
  const hrefAttribute = routed ? 'to' : 'href';
  const target = newTab ? '_blank' : '_self';

  return (
    <LinkElement
      {...{[hrefAttribute]: to || ''}}
      data-testid="navbar-link"
      className={classnames(styles.link, className, {[styles.padding]: padding})}
      target={target}
    >
      {title}
    </LinkElement>
  );
};

export default NavbarLink;
